import { create } from 'zustand';

export const useProductsSearchStore = create((set) => ({
  searchInput: '',

  setSearchInput: (searchInput) => set({ searchInput }),
}));
